<script>
	import Footer from '@components/Footer.svelte';
	import Header from '@components/Header.svelte';
	import { setContext } from 'svelte';
	import { eventFilterSelections } from '@stores/eventFilterSelections';
	import { eventFilterOptions } from '@stores/eventFilterOptions';
	import { userStore } from '@stores/user';
	import { eventStore } from '@stores/event';
	import TrackingScript from '@components/TrackingScript.svelte';
	import '../app.css';

	setContext('eventStore', eventStore);
	setContext('eventFilterSelectionsStore', eventFilterSelections);
	setContext('eventFilterOptionsStore', eventFilterOptions);
	setContext('userStore', userStore);
</script>

<TrackingScript />

<Header />

<div class="bg-gray-12">
	<main class="content pb-14 lg:pb-16">
		<slot />
	</main>
</div>
<Footer />

<style>
	:root {
		--header-height-sm: 3.75rem;
		--header-height-lg: 5.25rem;
		--header-height-xl: 6rem;
		--header-height-xxl: 7.5rem;
		--footer-height-sm-xl: 10.75rem;
		--footer-height-xxl: 9.625rem;
		--content-max-width: 100.25rem;
		/* --content-max-width: calc(100vw - 80px); */
		--content-padding-sm: 0.75rem;
		--content-padding-md: 1rem;
		--content-padding-lg: 2.5rem;
	}

	.content {
		max-width: var(--content-max-width);
		margin: 0 auto;
		/* TODO: probably needs adjustments after header tweaks */
		min-height: calc(100dvh - var(--header-height-sm) - var(--footer-height-sm-xl));

		@media screen and (min-width: 1024px) {
			min-height: calc(100dvh - var(--header-height-lg) - var(--footer-height-sm-xl));
		}

		@media screen and (min-width: 1344px) {
			min-height: calc(100dvh - var(--header-height-xl) - var(--footer-height-sm-xl));
		}

		@media screen and (min-width: 1680px) {
			min-height: calc(100dvh - var(--header-height-xxl) - var(--footer-height-xxl));
		}
	}

	.content :global(.content-module-padding) {
		margin-left: var(--content-padding-sm);
		margin-right: var(--content-padding-sm);
	}

	@media (min-width: 768px) {
		.content :global(.content-module-padding) {
			margin-left: var(--content-padding-md);
			margin-right: var(--content-padding-md);
		}
	}
	@media (min-width: 1366px) {
		.content :global(.content-module-padding) {
			margin-left: var(--content-padding-lg);
			margin-right: var(--content-padding-lg);
		}
	}

	@media (min-width: 1604px) {
		.content :global(.content-module-padding) {
			max-width: calc(100vw - 5rem);
		}
	}
</style>
